import { useAction } from '@reatom/npm-react'

import { pairFocusEvent } from '@root/entities/pair'
import { WalletAssetsCurrencyCell } from '@root/entities/wallet/ui/table/column/wallet-asset-column/wallet-asset-currency-cell'

import type { UserProfileHoldingsWalletAsset } from '../../model/user-profile-holdings-wallet-asset'

export const HoldingsAssetsTokenCell = ({
  asset,
}: {
  asset: UserProfileHoldingsWalletAsset
}) => {
  const openPair = useAction(pairFocusEvent)
  const { pairAddress } = asset

  const handleClick = pairAddress
    ? (e: React.MouseEvent) => {
        e.stopPropagation()
        openPair({
          network: asset.currency.network,
          address: pairAddress,
        })
      }
    : undefined

  return (
    <WalletAssetsCurrencyCell
      currency={asset.currency}
      pairAddress={asset.pairAddress}
      trend={undefined}
      onClick={handleClick}
    />
  )
}
